import * as P from "./program-state"
let loaded_token = false

export const init_global_state = () => {
    const _window = window as any
    _window._eres_program_state = _ps
    // set global program state for 401 handling
    P.set_global_program_state(_ps.program_state)
    if (!loaded_token) {
        const token = _ps.program_state.token_load()
        if (token !== null) _ps.program_state.current = P.mk_empty_user_state(token)
        loaded_token = true
    }
}

export const _ps : P.program_state_box = { program_state : {...P.initial_program_state} }
